export const GET_SPEEDSYMBOLS_STATED = "GET_SPEEDSYMBOLS_STATED";
export const GET_SPEEDSYMBOLS = "GET_SPEEDSYMBOLS";
export const GET_SPEEDSYMBOLS_ENDED = "GET_SPEEDSYMBOLS_ENDED";
export const ADD_SPEEDSYMBOL_STATED = "ADD_SPEEDSYMBOL_STARTED";
export const ADD_SPEEDSYMBOL = "ADD_SPEEDSYMBOL";
export const ADD_SPEEDSYMBOL_ENDED = "ADD_SPEEDSYMBOL_ENDED";
export const EDIT_SPEEDSYMBOL_STATED = "EDIT_SPEEDSYMBOL_STATED";
export const EDIT_SPEEDSYMBOL = "EDIT_SPEEDSYMBOL";
export const EDIT_SPEEDSYMBOL_ENDED = "EDIT_SPEEDSYMBOL_ENDED";
export const GET_SPEEDSYMBOL = "GET_SPEEDSYMBOL";
export const GET_SPEEDSYMBOL_STATED = "GET_SPEEDSYMBOL_STATED";
export const GET_SPEEDSYMBOL_ENDED = "GET_SPEEDSYMBOL_ENDED";
export const RESET_SPEEDSYMBOL = "RESET_SPEEDSYMBOL";
export const ERROR_SPEEDSYMBOL = "ERROR_SPEEDSYMBOL";
export const GET_ALL_SPEEDSYMBOLS_STATED = "GET_ALL_SPEEDSYMBOLS_STATED";
export const GET_ALL_SPEEDSYMBOLS = "GET_ALL_SPEEDSYMBOLS";
export const GET_ALL_SPEEDSYMBOLS_ENDED = "GET_ALL_SPEEDSYMBOLS_ENDED";
